import { useQuery } from "@tanstack/react-query";
import { getGracePeriodInfo } from "../infrastructure/subscription.api";
import { useSubscriptionStatus } from "./use-subscription-status";

export function useGracePeriodInfo() {
  const { data: status } = useSubscriptionStatus();

  return useQuery({
    queryKey: ["subscription", "grace-period"],
    queryFn: getGracePeriodInfo,
    enabled: status?.status === "PastDue",
    staleTime: 2 * 60 * 1000,
    refetchInterval: 2 * 60 * 1000,
    retry: 1,
  });
}
